import React, { useState } from 'react';

const CalculadoraHC = ({
  alimentos,
  setAlimentos,
  alimentosPersonalizados,
  setAlimentosPersonalizados,
  alimentosComunes, // ahora se recibe por props
  modalAbierto,
  setModalAbierto,
  nuevoAlimento,
  setNuevoAlimento,
  glucosaActual,
  setGlucosaActual,
  unidadesInsulina,
  setUnidadesInsulina,
  totalCarbs,
  handleAlimentoChange,
  handleNumeroChange,
  autocompletarAlimento,
  agregarAlimento,
  eliminarAlimento,
  limpiarCalculadora,
  guardarAlimentoPersonalizado,
  eliminarAlimentoPersonalizado,
  añadirAlDiario,
  formatearNumero,
  onAddCustomFood,
  showTick
}) => {
  const [pendingSaveId, setPendingSaveId] = useState(null);
  const [pendingEditId, setPendingEditId] = useState(null);

  return (
    <>
      {/* Encabezado */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-center text-indigo-600">
          Calculadora HC
        </h1>
        <div className="mt-2 h-1 w-20 bg-indigo-500 mx-auto rounded-full"></div>
        <p className="mt-3 text-center text-gray-600 text-sm">
          Control de hidratos de carbono
        </p>
      </div>
      {/* Sección informativa y botón para añadir alimentos personalizados */}
      {/* (Eliminado el botón de añadir alimento personalizado) */}
      {/* Alimentos personalizados guardados */}
      {/* (Eliminado: ya no se muestra la sección 'Tus alimentos personalizados:') */}
      {/* Lista de alimentos */}
      <div className="space-y-5 mb-8">
        {alimentos.map((alimento, index) => {
          const nombreTrim = alimento.nombre.trim();
          // Comprobar existencia exacta (nombre y HC/100g)
          const existsExact = nombreTrim.length > 0 &&
            ([...alimentosPersonalizados, ...alimentosComunes].some(a => a.nombre.toLowerCase() === nombreTrim.toLowerCase() && Number(a.carbsPor100) === Number(alimento.carbsPor100)));
          // Comprobar existencia por nombre (para edición)
          const existsByName = nombreTrim.length > 0 &&
            ([...alimentosPersonalizados, ...alimentosComunes].some(a => a.nombre.toLowerCase() === nombreTrim.toLowerCase()));
          const alimentoBase =
            [...alimentosPersonalizados, ...alimentosComunes].find(a => a.nombre.toLowerCase() === nombreTrim.toLowerCase());
          // Si el usuario tiene un alimento personalizado con ese nombre, usar SIEMPRE ese como alimentoBase
          const alimentoPersonalizado = alimentosPersonalizados.find(a => a.nombre.toLowerCase() === nombreTrim.toLowerCase());
          const alimentoBaseFinal = alimentoPersonalizado || alimentoBase;
          const hcFilled = alimento.carbsPor100 > 0;
          // Solo permitir guardar si NO existe exactamente igual
          const readyToSave = nombreTrim.length > 0 && hcFilled && !existsByName;
          // Permitir editar si existe por nombre pero el HC/100g es diferente
          const readyToEdit = existsByName && hcFilled && alimentoBaseFinal && Number(alimentoBaseFinal.carbsPor100) !== Number(alimento.carbsPor100);
          return (
            <div key={alimento.id} className="p-4 bg-gray-50 rounded-lg transition duration-300 hover:shadow-md">
              {/* Save animation */}
              {pendingSaveId === alimento.id && (
                <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
                  <div className="bg-white bg-opacity-80 rounded-full p-8 shadow-lg animate-fade-tick">
                    <svg className="w-24 h-24 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 13l3 3 6-6" />
                    </svg>
                    <div className="text-green-700 text-xl font-bold text-center mt-2">Guardado</div>
                  </div>
                </div>
              )}
              {/* Edit animation */}
              {pendingEditId === alimento.id && (
                <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
                  <div className="bg-white bg-opacity-80 rounded-full p-8 shadow-lg animate-fade-tick">
                    <svg className="w-24 h-24 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 13l3 3 6-6" />
                    </svg>
                    <div className="text-yellow-700 text-xl font-bold text-center mt-2">Editado</div>
                  </div>
                </div>
              )}
              <div className="flex flex-col md:flex-row md:items-end gap-4">
                {/* Campo de Alimento */}
                <div className="w-full md:w-2/5">
                  <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1 block text-center md:text-left">Alimento</label>
                  <input
                    type="text"
                    className="w-full p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none transition text-center md:text-left"
                    value={alimento.nombre}
                    onChange={(e) => {
                      handleAlimentoChange(alimento.id, 'nombre', e.target.value);
                      setPendingSaveId(null);
                      // Autocompletar HC/100g automáticamente al seleccionar un alimento existente
                      const nombreSeleccionado = e.target.value.trim();
                      if (nombreSeleccionado.length > 0) {
                        const alimentoBase = [...alimentosPersonalizados, ...alimentosComunes].find(a => a.nombre.toLowerCase() === nombreSeleccionado.toLowerCase());
                        if (alimentoBase) {
                          handleAlimentoChange(alimento.id, 'carbsPor100', alimentoBase.carbsPor100);
                        }
                      }
                    }}
                    list={`alimentos-list-${alimento.id}`}
                    onBlur={(e) => autocompletarAlimento(alimento.id, e.target.value)}
                    placeholder="Ej: Arroz integral"
                  />
                  <datalist id={`alimentos-list-${alimento.id}`}>
                    {[
                      ...alimentosPersonalizados,
                      ...alimentosComunes.filter(a => !alimentosPersonalizados.some(ap => ap.nombre.toLowerCase() === a.nombre.toLowerCase()))
                    ]
                      .sort((a, b) => a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' }))
                      .map((a, idx) => (
                        <option key={a.nombre + idx} value={a.nombre} />
                      ))}
                  </datalist>
                </div>
                {/* Campos numéricos y botón eliminar */}
                <div className="flex flex-col items-center w-full">
                  <div className="flex flex-col sm:flex-row w-full gap-4">
                    <div className="relative w-full sm:w-1/2">
                      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1 block text-center">HC/100g</label>
                      <input
                        type="text"
                        inputMode="decimal"
                        min="0"
                        className="w-full p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none transition text-center"
                        value={alimento.carbsPor100 === 0 ? '' : alimento.carbsPor100}
                        onChange={(e) => {
                          const valor = e.target.value;
                          handleNumeroChange(alimento.id, 'carbsPor100', valor);
                          setPendingSaveId(null);
                        }}
                        onBlur={(e) => {
                          const valorConPunto = e.target.value.toString().replace(',', '.');
                          let valorNumerico = parseFloat(valorConPunto);
                          if (isNaN(valorNumerico)) valorNumerico = 0;
                          valorNumerico = Math.round(valorNumerico * 100) / 100;
                          handleAlimentoChange(alimento.id, 'carbsPor100', valorNumerico);
                        }}
                      />
                      {/* Guardar nuevo alimento o editar HC/100g botón */}
                      <div className="absolute top-full left-0 w-full mt-2 flex justify-center">
                        {readyToSave && (
                          <button
                            type="button"
                            className="flex items-center bg-green-100 hover:bg-green-200 text-green-700 text-xs px-2 py-1 rounded transition-colors border border-green-300 shadow-sm"
                            onClick={async () => {
                              const nuevoAlimento = { nombre: nombreTrim, carbsPor100: alimento.carbsPor100 };
                              await onAddCustomFood(nuevoAlimento);
                              setPendingSaveId(alimento.id);
                              setTimeout(() => setPendingSaveId(null), 1000);
                            }}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            ¿Quieres guardar este nuevo alimento?
                            <svg className="w-4 h-4 ml-1 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                          </button>
                        )}
                        {readyToEdit && (
                          <button
                            type="button"
                            className="flex items-center bg-yellow-100 hover:bg-yellow-200 text-yellow-800 text-xs px-2 py-1 rounded transition-colors border border-yellow-300 shadow-sm"
                            onClick={async () => {
                              const editAlimento = { nombre: nombreTrim, carbsPor100: alimento.carbsPor100 };
                              await onAddCustomFood(editAlimento);
                              setAlimentos(prev => prev.map(a =>
                                a.nombre.trim().toLowerCase() === nombreTrim.toLowerCase()
                                  ? { ...a, carbsPor100: alimento.carbsPor100 }
                                  : a
                              ));
                              setPendingEditId(alimento.id);
                              setTimeout(() => setPendingEditId(null), 1000);
                            }}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            ¿Quieres editar los hc/100g de este alimento?
                            <svg className="w-4 h-4 ml-1 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="w-full sm:w-1/2">
                      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1 block text-center">Cantidad (g)</label>
                      <input
                        type="text"
                        inputMode="decimal"
                        min="0"
                        className="w-full p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none transition text-center"
                        value={alimento.cantidad === 0 ? '' : alimento.cantidad}
                        onChange={(e) => {
                          const valor = e.target.value;
                          handleNumeroChange(alimento.id, 'cantidad', valor);
                          setPendingSaveId(null);
                        }}
                        onBlur={(e) => {
                          const valorConPunto = e.target.value.toString().replace(',', '.');
                          let valorNumerico = parseFloat(valorConPunto);
                          if (isNaN(valorNumerico)) valorNumerico = 0;
                          valorNumerico = Math.round(valorNumerico * 100) / 100;
                          handleAlimentoChange(alimento.id, 'cantidad', valorNumerico);
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* Botón eliminar */}
                <div className="flex justify-center md:justify-start md:ml-auto">
                  {index > 0 && (
                    <button
                      onClick={() => eliminarAlimento(alimento.id)}
                      className="p-2 text-red-400 hover:text-red-600 transition-colors"
                      title="Eliminar alimento"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  )}
                  {index === 0 && <div className="w-5 h-5"></div>}
                </div>
              </div>
              <style>{`
                @keyframes fade-tick {
                  0% { opacity: 0; transform: scale(0.8); }
                  20% { opacity: 1; transform: scale(1.1); }
                  80% { opacity: 1; transform: scale(1); }
                  100% { opacity: 0; transform: scale(0.8); }
                }
                .animate-fade-tick {
                  animation: fade-tick 1s cubic-bezier(0.4,0,0.2,1);
                }
              `}</style>
            </div>
          );
        })}
      </div>
      {/* Botones de acción */}
      <div className="flex flex-wrap sm:flex-nowrap justify-between gap-4 mb-8">
        <button
          onClick={agregarAlimento}
          className="flex items-center justify-center text-sm bg-indigo-500 hover:bg-indigo-600 text-white py-2 px-4 rounded-lg transition-colors shadow-sm w-full sm:w-auto"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-4 h-4 mr-1">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Añadir alimento
        </button>
        <button
          onClick={limpiarCalculadora}
          className="text-sm text-gray-500 hover:text-gray-700 py-2 px-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors w-full sm:w-auto"
        >
          Limpiar todo
        </button>
      </div>
      {/* Resultado */}
      <div className="bg-gradient-to-r from-indigo-500 to-purple-500 p-5 rounded-lg shadow-md text-white mb-6">
        <div className="flex flex-col items-center">
          <span className="text-sm font-medium mb-2">TOTAL DE HIDRATOS DE CARBONO</span>
          <div className="flex items-baseline">
            <span className="text-4xl font-bold">{totalCarbs.toFixed(1)}</span>
            <span className="ml-1 text-xl">g</span>
          </div>
        </div>
      </div>
      {/* Campos de glucosa, insulina y botón añadir al diario */}
      <div className="mb-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-4">
          <div className="flex flex-wrap justify-center gap-3 mb-3 md:mb-0">
            <div className="w-[140px]">
              <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1 block text-center">
                Glucosa actual
              </label>
              <input
                type="number"
                inputMode="numeric"
                min="0"
                max="999"
                className="w-full p-1.5 border border-gray-200 rounded-lg text-xs focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none transition text-center"
                value={glucosaActual}
                onChange={(e) => {
                  const valor = e.target.value;
                  if (valor === '' || (parseInt(valor) >= 0 && parseInt(valor) <= 999)) {
                    setGlucosaActual(valor);
                  }
                }}
                placeholder="Opcional"
              />
            </div>
            <div className="w-[140px]">
              <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1 block text-center">
                Unidades insulina
              </label>
              <input
                type="number"
                inputMode="numeric"
                min="0"
                max="99"
                className="w-full p-1.5 border border-gray-200 rounded-lg text-xs focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none transition text-center"
                value={unidadesInsulina}
                onChange={(e) => {
                  const valor = e.target.value;
                  if (valor === '' || (parseInt(valor) >= 0 && parseInt(valor) <= 99)) {
                    setUnidadesInsulina(valor);
                  }
                }}
                placeholder="Opcional"
              />
            </div>
          </div>
          <button
            onClick={añadirAlDiario}
            className="bg-green-500 hover:bg-green-600 text-white py-2 px-6 rounded-lg transition-colors shadow-sm inline-flex items-center"
          >
            {/* Icono disket clásico */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 mr-2">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
              <polyline points="17 21 17 13 7 13 7 21" />
              <polyline points="7 3 7 8 15 8" />
            </svg>
            Añadir al diario
          </button>
        </div>
      </div>
      {showTick && (
        <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
          <div className="bg-white bg-opacity-80 rounded-full p-8 shadow-lg animate-fade-tick">
            <svg className="w-24 h-24 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 13l3 3 6-6" />
            </svg>
            <div className="text-green-700 text-xl font-bold text-center mt-2">Guardado en diario</div>
          </div>
        </div>
      )}
      {/* Nota informativa */}
      <div className="mt-6 text-xs text-gray-400 italic text-center">
        <p>Los valores son aproximados. Consulta siempre con un profesional sanitario para una orientación personalizada.</p>
      </div>
      {/* Modal para añadir alimentos personalizados */}
      {modalAbierto && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full m-4 relative">
            <button 
              onClick={() => setModalAbierto(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <h3 className="text-xl font-bold text-gray-800 mb-4">Añadir alimento personalizado</h3>
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Nombre del alimento</label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none"
                  value={nuevoAlimento.nombre}
                  onChange={(e) => setNuevoAlimento({...nuevoAlimento, nombre: e.target.value})}
                  placeholder="Ej: Mi receta favorita"
                />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Hidratos de carbono por 100g</label>
                <input
                  type="text"
                  inputMode="decimal"
                  min="0"
                  step="0.1"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none"
                  value={nuevoAlimento.carbsPor100 === 0 ? '' : nuevoAlimento.carbsPor100}
                  onChange={(e) => {
                    const valor = e.target.value;
                    if (valor === '' || /^-?\d*[.,]?\d{0,2}$/.test(valor)) {
                      setNuevoAlimento({
                        ...nuevoAlimento, 
                        carbsPor100: valor
                      });
                    }
                  }}
                  onBlur={(e) => {
                    const valorConPunto = e.target.value.toString().replace(',', '.');
                    let valorNumerico = parseFloat(valorConPunto);
                    if (isNaN(valorNumerico)) valorNumerico = 0;
                    valorNumerico = Math.round(valorNumerico * 100) / 100;
                    setNuevoAlimento({
                      ...nuevoAlimento, 
                      carbsPor100: valorNumerico
                    });
                  }}
                  placeholder="Ej: 25.5"
                />
              </div>
              <div className="pt-2">
                <button
                  onClick={guardarAlimentoPersonalizado}
                  className="w-full bg-indigo-500 hover:bg-indigo-600 text-white py-2 px-4 rounded-lg transition-colors shadow-sm"
                >
                  Guardar alimento
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CalculadoraHC;